export const formArraysForRequests = (participants, immutableState, type) => {
	const added = []
	const removed = []

	const state = new Map()
	immutableState?.map(item => state.set(item?.uid, item))

	participants?.forEach(p => {
		const foundPlayer = state.get(p?.uid)

		if (!foundPlayer) {
			if (type === 'singles') {
				added.push(p?.uid)
			} else {
				added.push({ player1: p.player1?.uid, player2: p.player2?.uid })
			}
		}
	})

	immutableState?.forEach(p => {
		const foundParticipant = participants?.find(item => p?.uid === item?.uid)

		if (!foundParticipant) {
			removed.push(p?.uid)
		}
	})

	return {
		added,
		removed
	}
}

export const checkParticipantsOrder = (participants, immutableState) => {
	let orderIsChanged = false
	let seed = []

	if (immutableState?.length > 0) {
		for (let i = 0; i < immutableState.length; i++) {
			if (immutableState[i]?.uid !== participants[i]?.uid) {
				seed = participants?.map(p => p?.uid)
				orderIsChanged = true
				break
			}
		}
	}

	return {
		orderIsChanged,
		seed
	}
}


export const generateRandomUid = () => {
	const randomNumber = Math.floor(Math.random() * 100000).toString()
	const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26))
	const uid = `${randomLetter}${randomNumber}`
	return uid
}

